import CoreReactLegacyChangelogs from "../../../../../core-react/CHANGELOG_LEGACY.md";
import * as React from 'react';
export default {
  CoreReactLegacyChangelogs,
  React
};